const SET_LMS_COURSE = "SET_LMS_COURSE";

export const setCourseList = (payload) => {
    return {
        type: SET_LMS_COURSE,
        payload,
    };
};

const initialState = [];

export default (state = initialState, action) => {
    switch (action.type) {
        case SET_LMS_COURSE:
            if (!action.payload) {
                return initialState;
            }
            return [...action.payload];

        default:
            return state;
    }
};
